import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import MainContext from 'MainContext';
import * as API from '../container/api';

const StyledQuantity = styled.div`
  position: absolute;
  top: 0.895vw;
  right: ${(props) => (props.rtlDirection ? 'unset' : '0vw')};
  left: ${(props) => (props.rtlDirection ? '0vw' : 'unset')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 3.175vw;
  height: 2.654vw;
`;

const StyledMinesLine = styled.div`
  position: absolute;
  left: ${(props) => props.left};
  top: ${(props) => props.top};
  transform: rotate(${(props) => props.rotation}deg);
  width: 0.624vw;
  height: 2px;
  border-radius: 0.234vw;
  background-color: ${(props) => props.theme.textSecondary};
  transition: 200ms linear;
`;

const PlusIcon = styled.div`
  width: 0.624vw;
  height: 2px;
  transition: 200ms linear;

  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.grayIcons};
  font-size: 0.6vw;
`;

const StyledSignBox = styled.div`
  position: relative;
  width: 0.624vw;
  height: 0.624vw;
  cursor: pointer;
  &:hover {
    ${PlusIcon} {
      color: ${(props) => props.theme.icons};
      // background-color: ${(props) => props.theme.textPrimary};
    }
  }
`;

const StyledInput = styled.input`
  position: relative;
  text-align: center;
  border: 0px solid green;
  outline: none;
  background-color: #00000000;
  color: ${(props) => props.theme.textPrimary};
  font-weight: 500vw;
  font-size: 0.624vw;
`;

const App = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const {
    checkoutInvoice,
    setCheckoutInvoice,
    basketOrders,
    setCartContext } = useContext(MainContext).cart;
  const [quantityInput, setQuantityInput] = useState(0);
  const { quantity, id,invoiceId } = props;
  
  useEffect(() => {
    setQuantityInput(quantity);
  }, []);
  const updateCartOrders = (result) => {
    let orderList;
    if(invoiceId)
      orderList= checkoutInvoice.orders;
    else
      orderList= basketOrders;
    let helper = [...orderList];
    orderList.map((basketOrder, index) => {
      if (basketOrder._id === id) {
        helper[index].quantity = result.quantity;
        helper[index].price = result.price;
      }
    });
    if(invoiceId)
      setCheckoutInvoice({...checkoutInvoice, orders: helper });
    else
      setCartContext(helper);
  };

  const setQuantityFunc = async (value) => {
    if (value > 0) {
      let data = { quantity: value, order_id: id };
      const result = await API.updateOrderQuantity(data);
      updateCartOrders(result);
      setQuantityInput(value);
    }
  };

  const onQuantityChange = async (e) => {
    let value = Number(e.target.value);
    let data = { quantity: value, order_id: id };
    if (value > 0) {
      setQuantityInput(value);
      const result = await API.updateOrderQuantity(data);
      updateCartOrders(result);
    }
  };

  return (
    <StyledQuantity rtlDirection={rtlDirection} theme={theme}>
      <StyledSignBox onClick={() => setQuantityFunc(quantityInput + 1)} theme={theme}>
        <PlusIcon className="icon-plus" theme={theme} />
      </StyledSignBox>
      <StyledInput theme={theme} value={quantityInput} onChange={onQuantityChange} />
      <StyledSignBox onClick={() => setQuantityFunc(quantityInput - 1)} theme={theme}>
        <PlusIcon className="icon-minus" theme={theme} />
      </StyledSignBox>
    </StyledQuantity>
  );
};

export default App;
